module.exports = __webpack_public_path__ + "static/img/parker.c2cfb67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parker.jpg
// module id = lWcB
// module chunks = 0